// src/modules/app-views/leads/pages/Init/components/tableColumns/originColumn.js
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// Displays the traffic origin that brought the visitor to the landing page.
// Currently based on utm.source — if absent the visitor accessed the URL directly.
// Future: when the Marketing module is ready this column will also show
// campaign-specific sources (google, facebook, meta, etc.).
function originColumn(buildColumnProps, options = {}) {
  const {
    key = 'origin',
    title = 'origin',
    dataIndex = 'utm',
    width = 120,
    align = 'center',
    columnProps = { sort: false },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const source = r?.utm?.source;
      const cfg = getOriginConfig(source);
      return <Tag color={cfg.color}>{cfg.label}</Tag>;
    },
  };
}

export default originColumn;

// ---------------------------------------------------------------------------
// HELPERS
// ---------------------------------------------------------------------------

// Maps UTM source values to Tag color + label.
// Currently only 'url' (direct) is active.
// Add new entries here when the Marketing module introduces campaign sources.
function getOriginConfig(source) {
  const map = {
    google:   { color: 'blue',   label: 'Google' },
    facebook: { color: 'geekblue', label: 'Facebook' },
    meta:     { color: 'geekblue', label: 'Meta' },
    instagram:{ color: 'magenta', label: 'Instagram' },
    youtube:  { color: 'red',    label: 'YouTube' },
    email:    { color: 'cyan',   label: 'Email' },
    organic:  { color: 'green',  label: 'Organic' },
  };

  if (source && map[source.toLowerCase()]) {
    return map[source.toLowerCase()];
  }

  // No UTM source — visitor typed or shared the URL directly
  return { color: 'default', label: translateX('direct_url') };
}
